export default __webpack_public_path__ + "static/media/review.b2366188.svg";